import React from 'react';
import { TextInput, LongTextInput, CheckBox, NumberInput, DatePicker, DropdownSelector } from 'hyperdb-utils';

const Form = ({ review, properties = [], availableLanguages = [], onChange }) => {
  const handleClickCheckbox = (attributeName) => {
    const checked = !review[attributeName];
    onChange(attributeName, { value: checked });
  };
  const handleChangeRelation = (attributeName, field) => {
    const { name, value } = field;
    const reference = { ...review[attributeName] };
    reference.value[1] = value;
    onChange(attributeName, { value: reference });
  };
  const propertiesOptions = () => {
    return properties
      .map(property => {
        return { name: property.name, value: property.id };
      });
  };
  const languagesOptions = () => {
    return availableLanguages
      .map(lang => {
        return { name: lang, value: lang };
      });
  };

  return (
    <fieldset>
      <CheckBox
        label="validated"
        name="validated"
        checked={ review.validated }
        onChange={ handleClickCheckbox.bind(null, 'validated') }
      />
      <DropdownSelector
        label="property *"
        name="property"
        options={ propertiesOptions() }
        value={ review.property.value[1] }
        onChange={ handleChangeRelation.bind(null, 'property') }
      />
      <TextInput
        label="guest name *"
        name="guest_name"
        value={ review.guest_name }
        onChange={ onChange.bind(null, 'guest_name') }
      />
      <TextInput
        label="location"
        name="location"
        value={ review.location }
        onChange={ onChange.bind(null, 'location') }
      />
      <DatePicker
        label="date *"
        name="date"
        value={ review.date }
        onChange={ onChange.bind(null, 'date') }
      />
      <DropdownSelector
        label="language *"
        name="language"
        value={ review.language }
        onChange={ onChange.bind(null, 'language') }
        options={ languagesOptions() }
      />
      <LongTextInput
        label="comment"
        name="comment"
        value={ review.comment }
        onChange={ onChange.bind(null, 'comment') }
      />
      <fieldset>
        <legend>Ratings</legend>
        <NumberInput
          label="cleanliness"
          name="rating_cleanliness"
          value={ review.rating_cleanliness }
          onChange={ onChange.bind(null, 'rating_cleanliness') }
        />
        <NumberInput
          label="comfort"
          name="rating_comfort"
          value={ review.rating_comfort }
          onChange={ onChange.bind(null, 'rating_comfort') }
        />
        <NumberInput
          label="location"
          name="rating_location"
          value={ review.rating_location }
          onChange={ onChange.bind(null, 'rating_location') }
        />
        <NumberInput
          label="service"
          name="rating_service"
          value={ review.rating_service }
          onChange={ onChange.bind(null, 'rating_service') }
        />
        <NumberInput
          label="value for money"
          name="rating_value_for_money"
          value={ review.rating_value_for_money }
          onChange={ onChange.bind(null, 'rating_value_for_money') }
        />
      </fieldset>
    </fieldset>
  );
};

export default Form;



// WEBPACK FOOTER //
// ./src/frontend/modules/content/property-review/components/Form.jsx